import React from 'react';
import frontImage from "../../assets/Instructions/FrontPoseInstructions.png";
import sideImage from "../../assets/Instructions/SidePoseInstructions.png";
import { Lightbulb, Shirt, Footprints, Ribbon, MoveHorizontal, TriangleRight, ArrowUpFromLine } from 'lucide-react';

const iconSize = 36;

// Overlay definitions for front and side views
const frontOverlays = [
  {
    icon: <Lightbulb size={iconSize} />,  // light exposure
    text: "Make sure there's constant light exposure",
    style: { top: '15%', left: '90%' }
  },
  {
    icon: <Ribbon size={iconSize} />,    // hair tie
    text: 'Tie your hair if necessary',
    style: { top: '15%', left: '20%' }
  },
  {
    icon: <Footprints size={iconSize} />, // shoes removed
    text: 'Remove your shoes',
    style: { top: '90%', left: '20%' }
  },
  {
    icon: <Shirt size={iconSize} />,     // clothing
    text: 'Dress in tight clothes',
    style: { top: '65%', left: '90%' }
  },
  {
    icon: <TriangleRight size={iconSize} />,     // clothing
    text: '45° ',
    style: { top: '40%', left: '30%' }
  },
  {
    icon: <MoveHorizontal size={iconSize}></MoveHorizontal>,                           // measurement arrow
    text: '15 cm – 20 cm',
    style: { top: '100%', left: '50%' }
  }
];

const sideOverlays = [
  {
    icon: <Lightbulb size={iconSize} />,  // light exposure
    text: 'Make sure there is constant light exposure',
    style: { top: '20%', left: '80%' }
  },
  {
    icon: <Ribbon size={iconSize} />,    // hair tie
    text: 'Tie your hair if necessary',
    style: { top: '18%', left: '18%' }
  },
  {
    icon: <Shirt size={iconSize} />,     // tight clothes
    text: 'Dress in tight clothes',
    style: { top: '55%', left: '80%' }
  },
  {
    icon: <Footprints size={iconSize} />, // shoes removed
    text: 'Remove your shoes',
    style: { top: '90%', left: '18%' }
  },
  {
    icon: <ArrowUpFromLine size={iconSize} />, // shoes removed
    text: 'Stand straight',
    style: { top: '50%', left: '18%' }
  }
];

/**
 * Props:
 * - view: 'front' | 'side' (which overlay to show)
 */
const PoseOverlay = ({ view = 'front' }) => {
  const overlays = view === 'front' ? frontOverlays : sideOverlays;
  const imageSrc = view === 'front' ? frontImage : sideImage;
  const textColor = '#0088ff';

  return (
    <div className="relative inline-block mb-16 mt-16">
      <img
        src={imageSrc}
        alt={`${view} pose instructions`}
        className="max-h-[70vh] max-w-full w-auto h-auto justify-center mx-auto"
      />

      {overlays.map((item, idx) => (
        <div
          key={idx}
          className="absolute flex flex-col items-center font-semibold"
          style={{ color: textColor, ...item.style, transform: 'translate(-50%, -50%)' }}
        >
          {item.icon && <div className="mb-2">{item.icon}</div>}
          <div style={{ maxWidth: '140px', textAlign: 'center', lineHeight: '1.2' }}>
            {item.text}
          </div>
        </div>
      ))}

      {/* Measurement arrow: common for both views */}

    </div>
  );
};

export default PoseOverlay;
